import { useForms } from "queries/forms"
import { Email } from "sharedTypes"
import { ButtonBlock } from "sharedTypes/builder"

type Props = {
  eventId: string
  email?: Email
}

const useFormIntegrations = ({ eventId, email }: Props) => {
  const { isLoading, data } = useForms(eventId)

  if (!email) {
    return { data: [], isLoading, deletedFormsCount: 0 }
  }

  // Dedupe so a form linked from multiple blocks isn't miscounted as deleted.
  // Blank ids are kept so a "Diobox Form" block with no form picked still
  // counts as unresolved and blocks sending.
  const formIds = [...new Set(getFormIdsFromEmail(email))]
  const integratedForms = data?.data.filter((form) => formIds.includes(form.externalId)) || []
  const deletedFormsCount = formIds.length - integratedForms.length

  return {
    data: integratedForms,
    isLoading,
    deletedFormsCount,
  }
}

const getFormIdsFromEmail = (email: Email) => {
  const { emailData: { blocks } } = email

  return (blocks.filter(({ data }) => ("action" in data && data.action === "form"))
    .map((block) => (block as ButtonBlock).data.formId))
}

export default useFormIntegrations
